import PropTypes from 'prop-types'

const LogIcon = ({ className }: { className: string }) => (
  <svg width={48} height={48} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className={className}>
    <title>{'Builder/ Operation/ Log'}</title>
    <path
      d="M30 1.5A2.5 2.5 0 0132.5 4v1.5h15v38.8l-15.668 2.24-15.895-5.962L.5 44.988V5.5h15V4a2.5 2.5 0 012.336-2.495L18 1.5zm-14.5 7h-12v32.511l12.564-3.59 16.104 6.04L44.5 41.699V8.5h-12V10a2.5 2.5 0 01-2.336 2.495L30 12.5H18a2.5 2.5 0 01-2.5-2.5V8.5zm9.772 7.287l1.94.485-4.484 17.94-1.94-.484 4.484-17.94zM16 19.586L17.414 21l-3.999 4 4 4L16 30.414 10.586 25 16 19.586zm16 0L37.414 25 32 30.414 30.586 29l3.999-4-4-4L32 19.586zM29.5 4.5h-11v5h11v-5z"
      fill="#1A56DB"
      fillRule="nonzero"
    />
  </svg>
)

LogIcon.displayName = 'LogIcon'

LogIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

LogIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default LogIcon
